module.exports = __webpack_public_path__ + "static/media/31.171a2d5c.mp3";